(function(){
'use strict';
var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── višina offerbara → sticky offset navigacije ──────── */
var bar=document.getElementById('offerbar');
function setBar(){ document.documentElement.style.setProperty('--bar', bar.offsetHeight+'px'); }
setBar();
if(window.ResizeObserver) new ResizeObserver(setBar).observe(bar);
addEventListener('resize',setBar);

/* ── scroll progress + stuck nav + sticky buy ─────────── */
var nav=document.getElementById('nav'), prog=document.getElementById('prog'),
    sticky=document.getElementById('sticky');
function onScroll(){
  var y=window.scrollY, h=document.body.scrollHeight-innerHeight;
  prog.style.width=(h>0?(y/h)*100:0)+'%';
  nav.classList.toggle('stuck', y>40);
  sticky.classList.toggle('on', y>760);
}
addEventListener('scroll',onScroll,{passive:true}); onScroll();

/* ── burger + mobilni meni ───────────────────────────── */
var burger=document.getElementById('burger'), mob=document.getElementById('mobmenu');
function setMenu(open){
  mob.classList.toggle('open',open);
  burger.setAttribute('aria-expanded',String(open));
  burger.setAttribute('aria-label',open?'Zapri meni':'Odpri meni');
  document.body.style.overflow=open?'hidden':'';
}
burger.addEventListener('click',function(){ setMenu(!mob.classList.contains('open')); });
mob.addEventListener('click',function(e){ if(e.target.tagName==='A') setMenu(false); });

/* ── reveal on scroll ────────────────────────────────── */
var io=new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
},{threshold:.16,rootMargin:'0px 0px -8% 0px'});
document.querySelectorAll('.rv,#chart').forEach(function(el){ io.observe(el); });

/* ── števci ──────────────────────────────────────────── */
var cio=new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(!e.isIntersecting) return;
    var el=e.target, to=+el.dataset.count, pre=el.dataset.prefix||'', suf=el.dataset.suffix||'';
    cio.unobserve(el);
    if(RM){ el.textContent=pre+to+suf; return; }
    var t0=performance.now(), dur=1200;
    (function step(t){
      var p=Math.min((t-t0)/dur,1), v=Math.round(to*(1-Math.pow(1-p,3)));
      el.textContent=pre+v+suf;
      if(p<1) requestAnimationFrame(step);
    })(t0);
  });
},{threshold:.5});
document.querySelectorAll('[data-count]').forEach(function(el){ cio.observe(el); });

/* ── PAKETI + KOŠARICA ────────────────────────────────
   Enaka mehanika kot na strani matcha vs kava: gumb NI JS
   simulacija, ampak prava Shopify cart permalinka
   /cart/<variantId>:<qty>,... — klik doda izdelke in
   odpre košarico trgovine. Števec bere /cart.js.        */
var SHOP='';
var SAME_ORIGIN=(!SHOP || location.origin===SHOP);   /* prazen SHOP = relativno = ista domena */
var cartUrl=function(items){ return SHOP+'/cart/'+items; };
var $=function(sel){ return document.querySelector(sel); };
var $$=function(sel){ return [].slice.call(document.querySelectorAll(sel)); };

var cta=$('#cta'), stickyCta=$('#sticky-cta'),
    stickyPrice=$('#sticky-price'), stickyLabel=$('#sticky-label');

var izbran=null, subOn=false;
var subToggle=$('#subToggle'), subNote=$('#subNote');
var PLAN=6592725213;

function osveziPrikaz(){
  $$('.tier').forEach(function(t){
    var podpira = !subOn || !!t.dataset.plan;
    t.classList.toggle('nosub', !podpira);
    var tp=t.querySelector('.tp'), tpc=t.querySelector('.tpc');
    var tm=t.querySelector('.tm');
    if(!t.dataset.tmPrvi) t.dataset.tmPrvi=tm.textContent;
    if(subOn && t.dataset.subprice){
      tp.innerHTML='<s>'+t.dataset.price+' €</s> '+t.dataset.subprice+' €';
      tpc.textContent=t.dataset.subper+' € / skodelico';
      tm.textContent=t.dataset.subqty+'× matcha 50 g na mesec';
    }else{
      tm.textContent=t.dataset.tmPrvi;
      tp.innerHTML=t.dataset.prvi;
      tpc.textContent=t.dataset.per+' € / skodelico';
    }
  });
  /* če izbrani paket naročnine ne podpira, skoči na tistega, ki jo */
  if(subOn && izbran && !izbran.dataset.plan){
    var prvi=$$('.tier').filter(function(t){ return t.dataset.plan; })[0];
    if(prvi) izberi(prvi);
  }
  subNote.hidden=!subOn;
  if(subOn) subNote.textContent=
    'Naročnina pošilja samo matcho — vsak mesec po izbrani količini, −20 %. Darila (lonček, metlica, set, e-knjiga) so vključena pri enkratnem nakupu paketa.';
  if(izbran) izberi(izbran);
}

function izberi(t){
  $$('.tier').forEach(function(x){ x.classList.remove('on'); x.setAttribute('aria-pressed','false'); });
  t.classList.add('on'); t.setAttribute('aria-pressed','true');
  izbran=t;
  var sub = subOn && !!t.dataset.plan;
  var cena = (sub ? t.dataset.subprice : t.dataset.price)+' €';
  cta.innerHTML='Dodaj v košarico — '+cena+' <span class="ar">→</span>';
  stickyPrice.textContent=cena;
  stickyLabel.textContent=t.dataset.label+(sub?' · naročnina':'');
  if(sub){ cta.href=SHOP+'/cart'; stickyCta.href=SHOP+'/cart'; }
  else{ var u=cartUrl(t.dataset.cart); cta.href=u; stickyCta.href=u; }
  $$('.tinc').forEach(function(d){ d.open = (d.previousElementSibling===t); });
}

/* naročnina gre prek uradnega /cart/add.js s selling_plan */
function dodajNarocnino(e){
  if(!izbran || !subOn || !izbran.dataset.plan) return;   /* enkratni nakup gre po permalinki */
  e.preventDefault();
  var btn=e.currentTarget, prej=btn.innerHTML;
  btn.innerHTML='Dodajam …';
  fetch(SHOP+'/cart/add.js',{
    method:'POST', credentials:'same-origin',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:+izbran.dataset.variant,
                                 quantity:+(izbran.dataset.subqty||1), selling_plan:PLAN}]})
  }).then(function(r){
    if(r.ok){ location.href=SHOP+'/cart'; return; }
    return r.json().then(function(d){ throw new Error(d.description||'napaka'); });
  }).catch(function(err){
    btn.innerHTML=prej;
    subNote.hidden=false;
    subNote.textContent='Naročnine za ta paket ni bilo mogoče dodati ('+err.message+'). Poskusi enkratni nakup.';
  });
}

$$('.tier').forEach(function(t){
  t.dataset.prvi = t.querySelector('.tp').innerHTML;   /* zapomni si izvirni prikaz cene */
  t.addEventListener('click',function(){ izberi(t); });
});
if(subToggle) subToggle.addEventListener('change',function(){ subOn=subToggle.checked; osveziPrikaz(); });
if($('.tier.on')) izberi($('.tier.on'));

/* števec košarice — isti vir resnice kot ostale strani */
var POLL_MS=5000, cartEl=$('#cart'), cartCount=$('#cartCount'), prikazano=null;
function enote(str){ return str.split(',').reduce(function(a,p){ return a+(+p.split(':')[1]||0); },0); }
function narisi(n){
  if(n===prikazano) return;
  prikazano=n;
  cartCount.textContent=n;
  cartEl.classList.toggle('has',n>0);
  cartEl.setAttribute('aria-label', n>0 ? 'Košarica — '+n+' izdelkov' : 'Košarica (prazna)');
}
function beriCart(){
  if(!SAME_ORIGIN){ return narisi(+(localStorage.getItem('munchies_cart')||0)); }
  fetch(SHOP+'/cart.js',{credentials:'same-origin',cache:'no-store'})
    .then(function(r){ return r.ok?r.json():null; })
    .then(function(c){ if(c) narisi(c.item_count); })
    .catch(function(){});
}
var pollT=null;
function zacniPoll(){ if(!pollT) pollT=setInterval(beriCart,POLL_MS); }
function ustaviPoll(){ clearInterval(pollT); pollT=null; }
beriCart(); zacniPoll();
document.addEventListener('visibilitychange',function(){
  if(document.hidden){ ustaviPoll(); } else { beriCart(); zacniPoll(); }
});
addEventListener('pageshow',beriCart);
addEventListener('storage',function(e){ if(e.key==='munchies_cart') beriCart(); });
/* ob kliku takoj pokaži pričakovano količino, da ni videti mrtvo */
[cta,stickyCta].forEach(function(el){
  el.addEventListener('click',dodajNarocnino);
  el.addEventListener('click',function(){
    var t=$('.tier.on'); if(!t || t.dataset.plan) return;
    var n=enote(t.dataset.cart);
    localStorage.setItem('munchies_cart',n); narisi(n);
  });
});

/* ── ANIMACIJA GRAFA ──────────────────────────────────
   Dolžine poti izmerimo z getTotalLength(), da se krivulji
   narišeta točno od začetka do konca — fiksni dasharray je
   prej rezal ali puščal rep. Pika potuje po kortizolni poti.  */
(function(){
  var chart=document.getElementById('chart');
  if(!chart) return;
  var kort=document.getElementById('pKort'), kava=document.getElementById('pKava'),
      rider=document.getElementById('rider');

  /* dasharray nastavimo inline, dashoffset pa NE — sicer inline stil
     povozi .chart.play .dash{stroke-dashoffset:0} in črta se ne nariše */
  [kort,kava].forEach(function(p){
    var len=p.getTotalLength();
    p.style.setProperty('--len',len);
    p.style.strokeDasharray=len;
  });

  function vozi(trajanje,zamik){
    if(RM){ var k=kort.getPointAtLength(kort.getTotalLength());
            rider.setAttribute('cx',k.x); rider.setAttribute('cy',k.y); return; }
    var dolzina=kort.getTotalLength(), t0=null;
    function korak(t){
      if(t0===null) t0=t;
      var p=Math.min((t-t0-zamik)/trajanje,1);
      if(p>0){
        var e=1-Math.pow(1-p,3);                 /* ista krivulja kot CSS ease */
        var tocka=kort.getPointAtLength(dolzina*e);
        rider.setAttribute('cx',tocka.x); rider.setAttribute('cy',tocka.y);
      }
      if(p<1) requestAnimationFrame(korak);
    }
    requestAnimationFrame(korak);
  }

  var io2=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      io2.unobserve(e.target);
      chart.classList.add('play');
      vozi(2000,0);
    });
  },{threshold:.35});
  io2.observe(chart);
})();

/* ── galerija: menjava glavne slike ───────────────────── */
var main=document.getElementById('mainimg');
document.querySelectorAll('.thumb').forEach(function(b){
  b.addEventListener('click',function(){
    document.querySelectorAll('.thumb').forEach(function(x){ x.classList.remove('on'); });
    b.classList.add('on');
    main.src=b.dataset.full; main.alt=b.dataset.alt;
  });
});

/* ── lightbox ────────────────────────────────────────── */
var lb=document.getElementById('lb'), lbi=document.getElementById('lbimg');
document.querySelectorAll('.zoomable img').forEach(function(img){
  img.parentElement.addEventListener('click',function(){
    lbi.src=img.currentSrc||img.src; lbi.alt=img.alt; lb.classList.add('on');
    document.body.style.overflow='hidden';
  });
});
function closeLb(){ lb.classList.remove('on'); document.body.style.overflow=''; }
lb.addEventListener('click',closeLb);

/* ── popup ───────────────────────────────────────────── */
var pop=document.getElementById('pop'), lastFocus=null;

function odpriPop(){
  /* ne zlagaj modalov drug na drugega */
  if(pop.classList.contains('on')) return;
  if(document.getElementById('lb').classList.contains('on')) return;
  if(document.getElementById('mobmenu').classList.contains('open')) return;
  pop.classList.remove('thanks');            /* nazaj na vprašanje */
  lastFocus=document.activeElement;
  pop.classList.add('on'); pop.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  showDrink(drinkIx+1); startRot();
  var f=pop.querySelector('.pl'); if(f) f.focus();
}


/* ── pijače v popupu se vrtijo ── */
var POP_DRINKS=[{src:'https://cdn.shopify.com/s/files/1/0791/5143/1901/files/lp-kava-pop-strawberry.png',alt:'Munchies jagodna matcha'},
 {src:'https://cdn.shopify.com/s/files/1/0791/5143/1901/files/lp-kortizol-pop-mango.png',alt:'Munchies mango matcha'},
 {src:'https://cdn.shopify.com/s/files/1/0791/5143/1901/files/lp-kortizol-pop-ube.png',alt:'Munchies blueberry lavender matcha'},
 {src:'https://cdn.shopify.com/s/files/1/0791/5143/1901/files/lp-kava-pop-cutout.png',alt:'Munchies ledena matcha'}];
var POP_ROTATE_MS=3500, cutImg=pop.querySelector('.cut'), drinkIx=0, rotT=null;
POP_DRINKS.forEach(function(d){var i=new Image();i.src=d.src;});
var reduceM=matchMedia('(prefers-reduced-motion: reduce)').matches;
function showDrink(i){drinkIx=(i+POP_DRINKS.length)%POP_DRINKS.length;var d=POP_DRINKS[drinkIx];
 if(cutImg.getAttribute('src')===d.src)return;
 if(reduceM){cutImg.src=d.src;cutImg.alt=d.alt;return;}
 cutImg.classList.add('swap');
 setTimeout(function(){cutImg.src=d.src;cutImg.alt=d.alt;cutImg.classList.remove('swap');},450);}
function startRot(){stopRot();if(!reduceM)rotT=setInterval(function(){showDrink(drinkIx+1);},POP_ROTATE_MS);}
function stopRot(){clearInterval(rotT);rotT=null;}

/* ── vabljivi CTA: tresljaj + iskrice ── */
var PULSE_EVERY_MS=4000, SPARKS=9;
var glows=[].slice.call(document.querySelectorAll('.btn-cta')), vis=new Set();
if(glows.length && !reduceM){
  var vio=new IntersectionObserver(function(es){es.forEach(function(e){
    e.isIntersecting?vis.add(e.target):vis.delete(e.target);});},{threshold:.35});
  glows.forEach(function(b){vio.observe(b);});
  var spark=function(b){for(var i=0;i<SPARKS;i++){var sp=document.createElement('span');
    sp.className='spark';var a=Math.random()*Math.PI*2,d=46+Math.random()*54;
    sp.style.setProperty('--dx',Math.cos(a)*d+'px');
    sp.style.setProperty('--dy',Math.sin(a)*d*.62+'px');
    sp.style.setProperty('--dur',700+Math.random()*500+'ms');
    sp.style.width=sp.style.height=(4+Math.random()*5).toFixed(1)+'px';
    b.appendChild(sp);setTimeout(function(){sp.remove();},1300);}};
  var pulse=function(){if(document.hidden)return;vis.forEach(function(b){
    b.classList.remove('pulse');void b.offsetWidth;b.classList.add('pulse');
    if(SPARKS)spark(b);setTimeout(function(){b.classList.remove('pulse');},800);});};
  setTimeout(pulse,1800); setInterval(pulse,PULSE_EVERY_MS);
}

/* enkrat, po prvi minuti — nato nikoli več (velja za celoten obisk) */
var POP_KEY='munchies_pop_kortizol';
if(!localStorage.getItem(POP_KEY)){
  setTimeout(function(){
    if(localStorage.getItem(POP_KEY)) return;
    localStorage.setItem(POP_KEY,'1');
    odpriPop();
  },60000);
}

window.closePop=function(){
  pop.classList.remove('on'); pop.setAttribute('aria-hidden','true');
  document.body.style.overflow=''; stopRot();
  if(lastFocus) lastFocus.focus();
};
window.pick=function(seg){
  console.log('segment:',seg);
  pop.classList.add('thanks');
  pop.querySelector('.code').textContent=({popoldne:'POPOLDNE10',jutro:'JUTRO10',kava:'KAVA10',okus:'OKUS10'})[seg];
  pop.querySelector('.done .btn').focus();
};
/* focus trap + esc */
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'){
    if(lb.classList.contains('on')) closeLb();
    else if(pop.classList.contains('on')) closePop();
  }
  if(e.key!=='Tab'||!pop.classList.contains('on')) return;
  var f=[].slice.call(pop.querySelectorAll('button,a[href],input')).filter(function(el){
    return el.offsetParent!==null; });
  if(!f.length) return;
  var first=f[0], lastEl=f[f.length-1];
  if(e.shiftKey && document.activeElement===first){ e.preventDefault(); lastEl.focus(); }
  else if(!e.shiftKey && document.activeElement===lastEl){ e.preventDefault(); first.focus(); }
});
})();
